import * as H from 'history';
import { ROUTES } from '../constants/routes';

const checkIfStockPageService = {
  isInStockDetailsPage(history: H.History): boolean {
    return history.location.pathname.includes(ROUTES.STOCK_DETAIL_FROM_CUSTOMISE);
  },
};

export default checkIfStockPageService;
